import { jsx } from "react/jsx-runtime";
import AntResult from "antd/es/result";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
import './Result.css';/* empty css            */
const Result = ({ className, title, subTitle, ...props }) => {
  return /* @__PURE__ */ jsx(
    AntResult,
    {
      title: /* @__PURE__ */ jsx(Typography.Title, { color: "darkest", headingLevel: 3, level: "h1", className: classnames("perxis-auto-result__title"), children: title }),
      subTitle: /* @__PURE__ */ jsx(Typography.Title, { color: "dark", headingLevel: 4, level: "h4", className: classnames("perxis-auto-result__sub-title"), children: subTitle }),
      className: classnames(className, "perxis-auto-result"),
      ...props
    }
  );
};
export {
  Result as default
};
//# sourceMappingURL=Result.js.map
